import { inject, Injectable } from '@angular/core';

import { JourneyAnalyticsLoader } from './journey-analytics-loader.service';

/**
 * Returns the instantiated analytics service.
 * Either the Rudderstack SDK or a stub, based on environment configuration.
 *
 * This facade is meant to control what methods to expose from the underlying Charon SDK,
 * consider it the public API for all consuming teams.
 */
@Injectable({ providedIn: 'root' })
export class JourneyAnalytics {
  readonly #loader = inject(JourneyAnalyticsLoader);
  readonly #analytics = this.#loader.getInstance();

  #verifyProvider() {
    if (this.#analytics === null) {
      throw new Error(
        `No analytics instance is available yet. This means 'provideJourneyAnalytics' has not been provided in your application. 
      Please add this provider to your main module / component before using this service.`
      );
    }
  }

  get track() {
    this.#verifyProvider();
    return this.#analytics.track;
  }

  get identify() {
    this.#verifyProvider();
    return this.#analytics.client().identify;
  }

  get page() {
    this.#verifyProvider();
    return this.#analytics.client().page;
  }
}
